export default __webpack_public_path__ + "static/media/mumbaiqr.22468064.png";